import { Divider } from '@lighthouse/bui'
import type { FlowEdge, FlowNode } from '@lighthouse/shared'
import { getAllParentNodes, LinkDocument } from '@lighthouse/shared'
import { useNodeConnections, useReactFlow } from '@xyflow/react'
import React, { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { NodeSetting } from '../../NodeSetting'
import { NodeHeader } from '../NodeHeader'

interface NodeConfigureContainerProps {
    node: FlowNode
    onClose?: () => void
    // onChangeNodeConfig: (data: BaseFlowNode['data']) => void
}

export const NodeConfigureContainer: React.FC<NodeConfigureContainerProps> = ({ node, onClose }) => {
    const { control } = useFormContext()
    const { id: nodeId } = node
    const { getNodes, getEdges } = useReactFlow<FlowNode, FlowEdge>()
    const connections = useNodeConnections({ id: nodeId })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const edges = useMemo(() => getEdges(), [getEdges, connections])
    const nodeType = useWatch({ control, name: 'nodeType' })
    const allParentNodes = useMemo<FlowNode[]>(() => getAllParentNodes(nodeId, getNodes(), edges), [nodeId, getNodes, edges])

    return (
        <>
            <NodeHeader rightSection={<LinkDocument type={nodeType} />} onClose={onClose} node={node} />
            <Divider color="var(--color-gray-200)" />
            <NodeSetting nodeType={nodeType} allParentNodes={allParentNodes} />
        </>
    )
}
